import { isWeb } from "@stepapp/core";
import { initSentry } from "@stepapp/sentry";
import { applicationId, nativeApplicationVersion, nativeBuildVersion } from "expo-application";
import { version } from "../package.json";
import { getApiUrl } from "../src/config/urls";
import { AppProviders } from "../src/containers/AppProviders";

export const unstable_settings = {
  // Ensure that reloading on `/modal` keeps a back button present.
  initialRouteName: "index/index",
};

initSentry({
  dsn: "https://ec807bce34ac41e68c89bd5486c27446@o494561.ingest.sentry.io/4505555125469184",
  apiUrl: getApiUrl(),
  release: isWeb ? version : `${applicationId}@${nativeApplicationVersion}`,
  dist: isWeb ? version : nativeBuildVersion || "0",
  enabled: false,
});

export default function Layout() {
  return <AppProviders />;
}
